module.exports = __webpack_public_path__ + "zwickauer-energieversorgung.jpg?58179a2b2b97cc6c8bf95750be735c09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zwickauer-energieversorgung.jpg
// module id = 380
// module chunks = 0